import styled from 'styled-components/macro';
import { TYPOGRAPHY, COLORS } from 'styleguide';
import { ellipsis } from 'polished';

const LastMessage = styled.div`
  ${TYPOGRAPHY.caption}
  text-align: left;
  color: ${({ unread }) => (unread ? '#fff' : COLORS.gray60)};
  ${ellipsis()}
`;

export default LastMessage;
